
import { Vue, Component, Emit, Prop, Ref } from "vue-property-decorator";

@Component
export default class MapToolTip extends Vue {
  @Prop({ type: String }) content!: String;
  @Prop({ type: String }) title!: String;
  @Prop() id!: any;
  @Prop({ type: Boolean, default: false }) istip!: Boolean;
  @Prop({ type: Boolean, default: true }) visible!: Boolean;
  @Ref() tp!: Object;
  // @Emit("toolTip-click")
  // public mapClick(point: object) {}
}
